export const formatPrice = (price?: number, locale?: string) => {
  if (!price) return ""

  const hasDecimal = price % 1 !== 0
  const formatedCurrency =
    locale === "vi"
      ? price?.toLocaleString(locale) + " đ"
      : price?.toLocaleString(locale, { style: "currency", currency: "USD", minimumFractionDigits: hasDecimal ? 2 : 0 })

  return formatedCurrency
}
